import { pricingDrawerUiConstaints, PRICING_DRAWER_TYPE } from '@constants/pricing-drawer-ui';
import { BILLING_TYPE_MAP } from '@constants/billing';

const initialState = {
    isOpen: false,
    type: PRICING_DRAWER_TYPE.UPGRADE,
    step: 0,
    defaultPlan: BILLING_TYPE_MAP.PROFESSIONAL,
    // Optional overrides for the drawer header — callers pass i18n keys, BillingDrawer
    // resolves them with t(). Null falls back to the generic upgrade/change copy.
    titleKey: null,
    subtitleKey: null,
    directoriesLocation: null,
    data: {},
    loading: true,
};

export function pricingDrawerUi(state = initialState, action) {
    switch (action.type) {
        case pricingDrawerUiConstaints.SET_PRICING_DRAWER_OPEN:
            return {
                ...state,
                isOpen: action.payload.open,
                type: action.payload.type,
                defaultPlan: action.payload.defaultPlan || BILLING_TYPE_MAP.PROFESSIONAL,
                titleKey: action.payload.titleKey || null,
                subtitleKey: action.payload.subtitleKey || null,
                directoriesLocation: action.payload.directoriesLocation || null,
                step: 0,
                data: {},
                loading: true,
            };
        case pricingDrawerUiConstaints.SET_PRICING_DRAWER_STEP:
            return { ...state, step: action.payload, loading: true, data: {} };
        case pricingDrawerUiConstaints.PRICING_DRAWER_DATA_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        default:
            return state;
    }
}
